import resume from '../assets/pdf/MD Arshad Khan.pdf'
import ProfilePick from "../Images/ProfilePick.png"

export const headerData = {
    name: 'MD Arshad Khan',
    title: "Hello, I'm",
    desciption:"“ It's not all about how you work hard but it's about how you manage your time, resources. And Success isn’t always about greatness. It’s about consistency. Consistent hard work leads to success. Greatness will come. ” ",
    image: ProfilePick,
    resumePdf:`https://docs.google.com/document/d/1ML_o4Mz0_KV1k9C5duufa5vgK1Z0xBTU/edit`
    // resumePdf:resume
}
